import React from 'react';
import { SignalIcon, SignalSlashIcon, ClockIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

export function ConnectionStatus() {
  const { isOnline, isSlowConnection, connectionType } = useNetworkStatus();

  if (isOnline && !isSlowConnection) return null;

  const getStatusInfo = () => {
    if (!isOnline) {
      return {
        icon: <SignalSlashIcon className="w-4 h-4" />,
        message: 'You\'re offline',
        color: 'text-red-600',
        bgColor: 'bg-red-50',
        borderColor: 'border-red-200'
      };
    }

    if (isSlowConnection) {
      return {
        icon: <ClockIcon className="w-4 h-4" />,
        message: 'Slow connection detected',
        color: 'text-yellow-600',
        bgColor: 'bg-yellow-50',
        borderColor: 'border-yellow-200'
      };
    }

    return null;
  };

  const statusInfo = getStatusInfo();
  if (!statusInfo) return null;

  return (
    <div className={`${statusInfo.bgColor} ${statusInfo.borderColor} border rounded-lg p-3 mb-4`}>
      <div className="flex items-center space-x-2">
        {statusInfo.icon}
        <span className={`text-sm font-medium ${statusInfo.color}`}>
          {statusInfo.message}
        </span>
        {connectionType && (
          <span className="text-xs text-gray-500">
            ({connectionType})
          </span>
        )}
      </div>
    </div>
  );
}
